import { FC, ReactElement } from 'react';
import { useIntl } from 'react-intl';
import { EyeOff, EyeOn } from '@clds/icon';
import { Tooltip } from '@clds/tooltip';
import { Button } from '@clds/button';
import { messages } from '../../../i18n';
import styled from 'styled-components';
import { AssetVisibility } from '@cld/unicorn-api';

export interface AssetViewButtonProps {
  onClick?: () => void;
  viewMode: AssetVisibility;
}

const iconMap: Record<AssetVisibility, ReactElement> = {
  visible: <EyeOff data-test-specifier="off" />,
  notVisible: <EyeOn data-test-specifier="on" />,
};

const StyledEyeButton = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledButton = styled(Button)`
  padding: 0 12px;
  height: 30px;
`;

export const EyeButton: FC<AssetViewButtonProps> = ({ viewMode, onClick, ...rest }) => {
  const { formatMessage } = useIntl();
  return (
    <StyledEyeButton>
      <Tooltip
        placement="right"
        title={viewMode === 'notVisible' ? formatMessage(messages.guestBarTooltipDisplay) : formatMessage(messages.guestBarTooltipHide)}
      >
        <StyledButton {...rest} onClick={onClick} size="sm" leftSlot={iconMap[viewMode]} variant="error" />
      </Tooltip>
    </StyledEyeButton>
  );
};
